const plugin = require('tailwindcss/plugin')

module.exports = {
  content: [
    './resources/js/**/*.js',
    './resources/views/*.php',
    './resources/sass/purge-whitelist.txt'
  ],
  theme: {
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      black: '#000',
      white: '#fff',
      charcoal: '#060707',
      lightCharcoal: '#9b9b9b',
      green: '#4a7f74',
      coral: '#cea1a5',
      lightGrey: '#f9f9f9',
      grey: '#D8D8D8',
      pink: '#F3E9EA',
      orange: '#E1B190',
      yellow: '#ffd973',
      red: '#e65353',
      error: '#d90000',
      'light-red': '#e96c6c',
      'light-green': '#94D3C8',
      'light-yellow': '#FFE6A2',
      'light-orange': '#FFCFAE'
    },
    screens: {
      xxs: '20rem',
      xs: '23em',
      sm: '30em',
      'sm-landscape': { raw: '(min-width: 30em) and (max-height: 43.125em)' },
      md: '43.125em',
      mdxl: '46.75rem',
      lg: '56.875em',
      xl: '79.6875em',
      xxl: '95.75em'
    },
    extend: {
      backgroundColor: theme => theme('colors'),
      backgroundImage: {
        'chevron-down': "url('/img/chevron-down.svg')",
        'chevron-up': "url('/img/chevron-up.svg')",
        spinner: "url('/img/spinner.svg')"
      },
      backgroundPosition: {
        bottom: 'bottom',
        center: 'center',
        left: 'left',
        'left-bottom': 'left bottom',
        'left-top': 'left top',
        right: 'right',
        'right-3': 'right 0.75rem center',
        'right-4': 'right 1rem center',
        'right-bottom': 'right bottom',
        'right-top': 'right top',
        top: 'top'
      },
      backgroundSize: theme => ({
        auto: 'auto',
        cover: 'cover',
        contain: 'contain',
        ...theme('spacing')
      }),
      borderColor: theme => ({
        ...theme('colors'),
        default: theme('colors.gray.300', 'currentColor')
      }),
      borderOpacity: theme => theme('opacity'),
      borderRadius: {
        none: '0',
        sm: '0.125rem',
        default: '0.25rem',
        md: '0.375rem',
        lg: '0.5rem',
        xl: '0.75rem',
        '2xl': '1rem',
        '3xl': '1.5rem',
        '4xl': '2rem',
        '5xl': '2.5rem',
        '1/2': '50%',
        full: '9999px'
      },
      borderWidth: {
        default: '1px',
        0: '0',
        1.5: '1.5px',
        2: '2px',
        4: '4px',
        8: '8px',
        9: '10px',
        10: '12px',
        11: '14px',
        12: '16px',
        13: '18px',
        14: '20px'
      },
      boxShadow: {
        'light-green-xs': 'inset 0 0 0 1px rgba(74, 127, 116, .85), 0 0 3px 1px rgba(0, 0, 0, 0.2)',
        'light-green-sm': 'inset 0 0 0 2px rgba(74, 127, 116, .85), 0 0 3px 1px rgba(0, 0, 0, 0.2)',
        'light-yellow-xs': 'inset 0 0 0 1px #ebd088, 0 0 3px 1px rgba(0, 0, 0, 0.05)',
        'light-yellow-sm': 'inset 0 0 0 2px #ebd088, 0 0 3px 1px rgba(0, 0, 0, 0.05)',
        'light-orange-xs': 'inset 0 0 0 1px #E1B190, 0 0 3px 1px rgba(0, 0, 0, 0.05)',
        'light-orange-sm': 'inset 0 0 0 2px #E1B190, 0 0 3px 1px rgba(0, 0, 0, 0.05)',
        'light-red-xs': 'inset 0 0 0 1px #e65353, 0 0 3px 1px rgba(0, 0, 0, 0.2)',
        'light-red-sm': 'inset 0 0 0 2px #e65353, 0 0 3px 1px rgba(0, 0, 0, 0.2)',
        default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        '3xl': '0 0 40px 0 rgba(0, 0, 0, 0.2)',
        inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
        outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
        none: 'none'
      },
      divideColor: theme => theme('borderColor'),
      divideOpacity: theme => theme('borderOpacity'),
      divideWidth: theme => theme('borderWidth'),
      fill: theme => ({
        current: 'currentColor',
        ...theme('colors')
      }),
      flex: {
        1: '1 1 0%',
        auto: '1 1 auto',
        initial: '0 1 auto',
        none: 'none'
      },
      flexShrink: {
        0: '0',
        default: '1'
      },
      fontFamily: {
        body: ['Avenir'],
        sans: [
          'system-ui',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          '"Noto Sans"',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ['Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'],
        mono: ['Menlo', 'Monaco', 'Consolas', '"Liberation Mono"', '"Courier New"', 'monospace']
      },
      fontSize: {
        xxs: ['0.75rem', 1],
        xs: ['0.875rem', 1],
        'base-normal': ['1rem', '1'],
        base: ['1rem', '1.625'],
        sm: ['1.4375rem', '1.04'],
        md: ['1.75rem', '1.35'],
        xl: ['2.05rem', '1.3'],
        '2xl': ['2.375rem', '1.26'],
        '3xl': ['2.5rem', '1.25'],
        '4xl': ['3rem', '1.2'],
        '5xl': ['3.1875rem', '1.19'],
        '6xl': ['4.1875rem', '1.149'],
        '7xl': ['5.625rem', '1.11']
      },
      height: theme => ({
        auto: 'auto',
        ...theme('spacing'),
        80: '20rem',
        full: '100%',
        screen: '100vh'
      }),
      inset: (theme, { negative }) => ({
        0: '0',
        auto: 'auto',
        ...theme('spacing'),
        ...negative(theme('spacing')),
        full: '100%',
        screen: '100vh'
      }),
      letterSpacing: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em'
      },
      lineHeight: {
        none: '1',
        tight: '1.25',
        snug: '1.375',
        normal: '1.5',
        relaxed: '1.625',
        loose: '2',
        3: '.75rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        9: '2.25rem',
        10: '2.5rem'
      },
      listStyleType: {
        none: 'none',
        disc: 'disc',
        decimal: 'decimal'
      },
      margin: (theme, { negative }) => ({
        auto: 'auto',
        ...theme('spacing'),
        ...negative(theme('spacing'))
      }),
      maxHeight: {
        '75%': '75%',
        80: '20rem',
        120: '30rem',
        '75vh': '75vh',
        full: '100%',
        screen: '100vh'
      },
      maxWidth: (theme, { breakpoints }) => ({
        none: 'none',
        '1/2': '50%',
        full: '100%',
        105: '26.25rem',
        ...breakpoints(theme('screens'))
      }),
      minHeight: (theme, { negative }) => ({
        0: '0',
        66: '16.5rem',
        80: '20rem',
        116: '29rem',
        140: '35rem',
        170: '42.5rem',
        full: '100%',
        screen: '100vh'
      }),
      minWidth: (theme) => ({
        0: '0',
        37: '9.25rem',
        38: '9.5rem',
        90: '22.5rem',
        182: '45.5rem',
        250: '62.5rem',
        full: '100%'
      }),
      objectPosition: {
        bottom: 'bottom',
        center: 'center',
        left: 'left',
        'left-bottom': 'left bottom',
        'left-top': 'left top',
        right: 'right',
        'right-bottom': 'right bottom',
        'right-top': 'right top',
        top: 'top'
      },
      opacity: {
        0: '0',
        25: '0.25',
        40: '0.4',
        50: '0.5',
        60: '0.6',
        75: '0.75',
        100: '1'
      },
      order: {
        first: '-9999',
        last: '9999',
        none: '0',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12'
      },
      outline: {
        none: ['3px solid transparent', '0'],
        white: ['3px dashed white', '0'],
        black: ['3px dashed black', '0']
      },
      padding: theme => theme('spacing'),
      placeholderColor: theme => theme('colors'),
      placeholderOpacity: theme => theme('opacity'),
      space: (theme, { negative }) => ({
        ...theme('spacing'),
        ...negative(theme('spacing'))
      }),
      stroke: {
        current: 'currentColor',
        white: '#ffffff',
        charcoal: '#060707'
      },
      strokeWidth: {
        0: '0',
        1: '1',
        2: '2'
      },
      textColor: theme => theme('colors'),
      textOpacity: theme => theme('opacity'),
      width: theme => ({
        auto: 'auto',
        ...theme('spacing'),
        full: '100%',
        screen: '100vw'
      }),
      zIndex: {
        auto: 'auto',
        '-1': '-1',
        0: '0',
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60'
      },
      gap: theme => theme('spacing'),
      gridTemplateColumns: {
        none: 'none',
        1: 'repeat(1, minmax(0, 1fr))',
        2: 'repeat(2, minmax(0, 1fr))',
        3: 'repeat(3, minmax(0, 1fr))',
        4: 'repeat(4, minmax(0, 1fr))',
        5: 'repeat(5, minmax(0, 1fr))',
        6: 'repeat(6, minmax(0, 1fr))',
        7: 'repeat(7, minmax(0, 1fr))',
        8: 'repeat(8, minmax(0, 1fr))',
        9: 'repeat(9, minmax(0, 1fr))',
        10: 'repeat(10, minmax(0, 1fr))',
        11: 'repeat(11, minmax(0, 1fr))',
        12: 'repeat(12, minmax(0, 1fr))'
      },
      gridAutoColumns: {
        auto: 'auto',
        min: 'min-content',
        max: 'max-content',
        fr: 'minmax(0, 1fr)'
      },
      gridColumn: {
        auto: 'auto',
        'span-1': 'span 1 / span 1',
        'span-2': 'span 2 / span 2',
        'span-3': 'span 3 / span 3',
        'span-4': 'span 4 / span 4',
        'span-5': 'span 5 / span 5',
        'span-6': 'span 6 / span 6',
        'span-7': 'span 7 / span 7',
        'span-8': 'span 8 / span 8',
        'span-9': 'span 9 / span 9',
        'span-10': 'span 10 / span 10',
        'span-11': 'span 11 / span 11',
        'span-12': 'span 12 / span 12',
        'span-full': '1 / -1'
      },
      gridColumnStart: {
        auto: 'auto',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
        13: '13'
      },
      gridColumnEnd: {
        auto: 'auto',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
        13: '13'
      },
      gridTemplateRows: {
        none: 'none',
        1: 'repeat(1, minmax(0, 1fr))',
        2: 'repeat(2, minmax(0, 1fr))',
        3: 'repeat(3, minmax(0, 1fr))',
        4: 'repeat(4, minmax(0, 1fr))',
        5: 'repeat(5, minmax(0, 1fr))',
        6: 'repeat(6, minmax(0, 1fr))'
      },
      gridAutoRows: {
        auto: 'auto',
        min: 'min-content',
        max: 'max-content',
        fr: 'minmax(0, 1fr)'
      },
      gridRow: {
        auto: 'auto',
        'span-1': 'span 1 / span 1',
        'span-2': 'span 2 / span 2',
        'span-3': 'span 3 / span 3',
        'span-4': 'span 4 / span 4',
        'span-5': 'span 5 / span 5',
        'span-6': 'span 6 / span 6',
        'span-full': '1 / -1'
      },
      gridRowStart: {
        auto: 'auto',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7'
      },
      gridRowEnd: {
        auto: 'auto',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7'
      },
      transformOrigin: {
        center: 'center',
        top: 'top',
        'top-right': 'top right',
        right: 'right',
        'bottom-right': 'bottom right',
        bottom: 'bottom',
        'bottom-left': 'bottom left',
        left: 'left',
        'top-left': 'top left'
      },
      scale: {
        0: '0',
        50: '.5',
        75: '.75',
        90: '.9',
        95: '.95',
        100: '1',
        105: '1.05',
        110: '1.1',
        125: '1.25',
        150: '1.5',
        300: '3'
      },
      rotate: {
        '-180': '-180deg',
        '-90': '-90deg',
        '-45': '-45deg',
        '-12': '-12deg',
        '-6': '-6deg',
        '-3': '-3deg',
        '-2': '-2deg',
        '-1': '-1deg',
        0: '0',
        1: '1deg',
        2: '2deg',
        3: '3deg',
        6: '6deg',
        12: '12deg',
        45: '45deg',
        90: '90deg',
        180: '180deg'
      },
      translate: (theme, { negative }) => ({
        ...theme('spacing'),
        ...negative(theme('spacing')),
        '-full': '-100%',
        '-1/2': '-50%',
        '1/2': '50%',
        full: '100%'
      }),
      skew: {
        '-12': '-12deg',
        '-6': '-6deg',
        '-3': '-3deg',
        '-2': '-2deg',
        '-1': '-1deg',
        0: '0',
        1: '1deg',
        2: '2deg',
        3: '3deg',
        6: '6deg',
        12: '12deg'
      },
      transitionProperty: {
        none: 'none',
        all: 'all',
        default: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
        colors: 'background-color, border-color, color, fill, stroke',
        opacity: 'opacity',
        shadow: 'box-shadow',
        transform: 'transform',
        'max-height': 'max-height',
        top: 'top'
      },
      transitionTimingFunction: {
        linear: 'linear',
        in: 'cubic-bezier(0.4, 0, 1, 1)',
        out: 'cubic-bezier(0, 0, 0.2, 1)',
        'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
      },
      transitionDuration: {
        75: '75ms',
        100: '100ms',
        150: '150ms',
        200: '200ms',
        300: '300ms',
        500: '500ms',
        700: '700ms',
        1000: '1000ms'
      },
      transitionDelay: {
        75: '75ms',
        100: '100ms',
        150: '150ms',
        200: '200ms',
        300: '300ms',
        500: '500ms',
        700: '700ms',
        1000: '1000ms'
      },
      animation: {
        none: 'none',
        spin: 'spin 1s linear infinite',
        ping: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
        pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
        bounce: 'bounce 1s infinite',
        progress: 'progress 1s linear infinite',
        opacity: 'opacity .3s linear 1',
        'limited-ping': 'ping 1s cubic-bezier(0, 0, 0.2, 1) 3'
      },
      keyframes: {
        spin: {
          to: { transform: 'rotate(360deg)' }
        },
        ping: {
          '75%, 100%': { transform: 'scale(2)', opacity: '0' }
        },
        pulse: {
          '50%': { opacity: '.5' }
        },
        bounce: {
          '0%, 100%': {
            transform: 'translateY(-25%)',
            animationTimingFunction: 'cubic-bezier(0.8,0,1,1)'
          },
          '50%': {
            transform: 'none',
            animationTimingFunction: 'cubic-bezier(0,0,0.2,1)'
          }
        },
        progress: {
          from: { width: '0%' },
          to: { width: '100%' }
        },
        opacity: {
          from: { opacity: '0%' },
          to: { opacity: '100%' }
        }
      },
      spacing: {
        screen50X: '50vw',
        screen50Y: '50vh',
        screenX: '100vw',
        screenY: '100vh',
        full: '100%',
        '1/2': '50%',
        '3/2': '150%',
        '1/3': '33.333333%',
        '2/3': '66.666667%',
        '1/4': '25%',
        '2/4': '50%',
        '3/4': '75%',
        '1/5': '20%',
        '2/5': '40%',
        '3/5': '60%',
        '4/5': '80%',
        '1/6': '16.666667%',
        '2/6': '33.333333%',
        '3/6': '50%',
        '4/6': '66.666667%',
        '5/6': '83.333333%',
        '1/12': '8.333333%',
        '2/12': '16.666667%',
        '3/12': '25%',
        '4/12': '33.333333%',
        '5/12': '41.666667%',
        '6/12': '50%',
        '7/12': '58.333333%',
        '8/12': '66.666667%',
        '9/12': '75%',
        '10/12': '83.333333%',
        '11/12': '91.666667%',
        portrait: '133%',
        max: '999em',
        px: '1px',
        0: '0',
        0.25: '0.0625rem',
        0.5: '0.125rem',
        1: '0.25rem',
        2: '0.5rem',
        3: '0.75rem',
        3.5: '0.875rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        7: '1.75rem',
        8: '2rem',
        9: '2.25rem',
        10: '2.5rem',
        11: '2.75rem',
        12: '3rem',
        13: '3.25rem',
        13.5: '3.375rem',
        14: '3.5rem',
        15: '3.75rem',
        16: '4rem',
        16.5: '4.125rem',
        17: '4.25rem',
        18: '4.5rem',
        19: '4.75rem',
        20: '5rem',
        21: '5.25rem',
        21.5: '5.375rem',
        22: '5.5rem',
        22.25: '5.5625rem',
        22.5: '5.625rem',
        23: '5.75rem',
        24: '6rem',
        25: '6.25rem',
        26: '6.5rem',
        29: '7.25rem',
        29.5: '7.375rem',
        32: '8rem',
        38: '9.5rem',
        40: '10rem',
        48: '12rem',
        56: '14rem',
        64: '16rem'
      }
    }
  },
  plugins: [
    require('tailwindcss-pseudo-elements'),
    plugin(({ addUtilities }) => {
      addUtilities({
        '.content-none': {
          content: 'none'
        },
        '.overflow-scrolling': {
          '-webkit-overflow-scrolling': 'auto'
        },
        '.content-before-none::before': {
          content: 'none'
        },
        '.content-after-none::after': {
          content: 'none'
        },
        '.tooltip': {
          'border-radius': '0 !important',
          'font-size': '1rem !important'
        },
        '.border-triangle': {
          'border-color': 'transparent transparent #F3E9EA transparent'
        },
        '.text-last-center': {
          'text-align-last': 'center'
        },
        '.cursor-none': {
          cursor: 'none'
        }
      })
    })
  ]
}
